import { connect } from 'react-redux';
import Dashboard from '../../../modules/common/Dashboard';
import { setIsDashboardOpen, setIsLoading } from '../../common.duck';
import {
  getSavedConfigsForUser,
  removeUserConfig,
  loadFromSavedUserConfig
} from '../../customizer.duck';

const mapStateToProps = ({ common, customizer }) => ({
  isDashboardOpen: common.isDashboardOpen,
  userId: customizer.userId,
  savedUserConfigs: customizer.savedUserConfigs
});

const mapDispatchToProps = dispatch => ({
  setIsDashboardOpen: bool => {
    dispatch(setIsDashboardOpen(bool));
  },
  getSavedConfigsForUser: (userId, type) => {
    dispatch(getSavedConfigsForUser(userId, type));
  },
  removeUserConfig: (userId, userConfigId) => {
    dispatch(setIsLoading(true));
    dispatch(removeUserConfig(userId, userConfigId));
  },
  loadFromSavedUserConfig: userConfig => {
    dispatch(loadFromSavedUserConfig(userConfig));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
